import { DirectorProfile } from '../../types';
import { cloudinaryImage, cloudinaryVideo, cloudinaryStaticPoster } from '../../shared/cloudinary';

const ASSET_BASE = 'd741c0fc08c4b708d02d9ccd7a69c7a9-1772740262';
const WORKSAMPLE_BASE = '0e52990c1141f99632dcea46c6374972-177385190';
const REEL_V2_BASE = '60fff9f177c78cb5ce44f73a1c26b73d-17742838481';

const v = (suffix: string, params?: string) => cloudinaryVideo(`${ASSET_BASE}${suffix}`, params);
const vp = (suffix: string) => cloudinaryStaticPoster(`${ASSET_BASE}${suffix}`, 800);
const vt = (suffix: string) => cloudinaryStaticPoster(`${ASSET_BASE}${suffix}`, 400);
const wsv = (suffix: string, params?: string) => cloudinaryVideo(`${WORKSAMPLE_BASE}${suffix}`, params);
const wsvp = (suffix: string) => cloudinaryStaticPoster(`${WORKSAMPLE_BASE}${suffix}`, 800);
const wsvt = (suffix: string) => cloudinaryStaticPoster(`${WORKSAMPLE_BASE}${suffix}`, 400);
const rv2 = (suffix: string, params?: string) => cloudinaryVideo(`${REEL_V2_BASE}${suffix}`, params);
const rv2p = (suffix: string) => cloudinaryStaticPoster(`${REEL_V2_BASE}${suffix}`, 800);
const rv2t = (suffix: string) => cloudinaryStaticPoster(`${REEL_V2_BASE}${suffix}`, 400);

export const DIRECTORS_SECTION_TITLE = 'Best-in-Class AI Video Directors.\nAll in one place.';
export const DIRECTORS_CTA_TEXT = 'Contact our production team';

export const HOLLYWOOD_DIRECTORS: DirectorProfile[] = [
    {
        id: 'billy-boman',
        name: 'Billy Boman',
        role: 'Creator · Writer · Editor',
        bio: "Billy Boman's 20-year career spans fashion, tech and visual design. Based in Stockholm, he leads Billy Boman AI Productions, a boutique studio helping brands move at the speed of culture through AI-driven production.\n\nHis work ranges from music videos and social content to Super Bowl commercials, with clients including YouTube, Google, Ballantine's, Klarna, and Universal Music Group.",
        tags: ['Music Videos', 'Commercials', 'Social Campaigns'],
        avatarImageUrl: cloudinaryImage('76f983e686d06d8dd4828749ca82454e-1773222009647/boman.png', 320),
        hoverImageUrl: cloudinaryImage('76f983e686d06d8dd4828749ca82454e-1773222009647/boman.png', 320),
        reel: {
            id: 'billy-boman-reel',
            title: 'Reel',
            videoUrl: v('993/billy-boman-reel-h', 'w_800'),
            videoUrlVertical: v('977/billy-boman-reel-v', 'w_400'),
            posterUrl: vp('993/billy-boman-reel-h'),
            thumbnailUrl: vt('993/billy-boman-reel-h'),
        },
        videos: [
            {
                id: 'billy-boman-1',
                title: 'Video 1',
                videoUrl: v('982/billy-boman-1', 'w_800'),
                posterUrl: vp('982/billy-boman-1'),
                thumbnailUrl: vt('982/billy-boman-1'),
            },
            {
                id: 'billy-boman-2',
                title: 'Video 2',
                videoUrl: v('992/billy-boman-2', 'w_800'),
                posterUrl: vp('992/billy-boman-2'),
                thumbnailUrl: vt('992/billy-boman-2'),
            },
            {
                id: 'billy-boman-3',
                title: 'Video 3',
                videoUrl: v('974/billy-boman-3', 'w_800'),
                posterUrl: vp('974/billy-boman-3'),
                thumbnailUrl: vt('974/billy-boman-3'),
            },
            {
                id: 'billy-boman-4',
                title: 'Video 4',
                videoUrl: v('990/billy-boman-4', 'w_800'),
                posterUrl: vp('990/billy-boman-4'),
                thumbnailUrl: vt('990/billy-boman-4'),
            },
        ],
        clients: ['Youtube', 'Klarna', 'Google', 'Universal Music Group'],
    },
    {
        id: 'haggar-shoval',
        name: 'Haggar Shoval',
        role: 'Editor · Screenwriter · Composer',
        bio: 'Haggar Shoval is an award-winning AI filmmaker, video editor, and screenwriter with over 22 years in television. She creates emotionally driven films that blend philosophical storytelling with hyper-real visuals and advanced AI tools. A pianist and composer, Haggar brings strong musical rhythm and sensitivity to each project, crafting immersive visual and sonic experiences. Her work has earned recognition at festivals such as the AI International Film Festival.',
        tags: ['Short Films', 'Experimental Film', 'AI Cinema'],
        avatarImageUrl: cloudinaryImage('96f313417f948ec79409c30925ca05a2-1773222061140/shoval.png', 320),
        hoverImageUrl: cloudinaryImage('96f313417f948ec79409c30925ca05a2-1773222061140/shoval.png', 320),
        reel: {
            id: 'haggar-shoval-reel',
            title: 'Reel',
            videoUrl: v('987/haggar-shoval-reel-h', 'w_800'),
            videoUrlVertical: v('991/haggar-shoval-reel-v', 'w_400'),
            posterUrl: vp('987/haggar-shoval-reel-h'),
            thumbnailUrl: vt('987/haggar-shoval-reel-h'),
        },
        videos: [
            {
                id: 'haggar-shoval-1',
                title: 'Video 1',
                videoUrl: v('986/hagar-shoval-1', 'w_800'),
                posterUrl: vp('986/hagar-shoval-1'),
                thumbnailUrl: vt('986/hagar-shoval-1'),
            },
            {
                id: 'haggar-shoval-2',
                title: 'Video 2',
                videoUrl: v('973/hagar-shoval-2', 'w_800'),
                posterUrl: cloudinaryStaticPoster(`${ASSET_BASE}973/hagar-shoval-2`, 800, 1),
                thumbnailUrl: cloudinaryStaticPoster(`${ASSET_BASE}973/hagar-shoval-2`, 400, 1),
            },
            {
                id: 'haggar-shoval-3',
                title: 'Video 3',
                videoUrl: wsv('2317/hagar-shoval-3-small', 'w_800'),
                posterUrl: cloudinaryStaticPoster(`${WORKSAMPLE_BASE}2317/hagar-shoval-3-small`, 800, 1),
                thumbnailUrl: cloudinaryStaticPoster(`${WORKSAMPLE_BASE}2317/hagar-shoval-3-small`, 400, 1),
            },
            {
                id: 'haggar-shoval-4',
                title: 'Video 4',
                videoUrl: wsv('2313/hagar-shoval-4-small', 'w_800'),
                posterUrl: wsvp('2313/hagar-shoval-4-small'),
                thumbnailUrl: wsvt('2313/hagar-shoval-4-small'),
            },
        ],
        awards: [
            'Winner, Laaimpa',
            'Top 11 Finalist, fal Chroma Awards 2025',
            'Winner of Best Artificial Intelligence Film for \u201CThe One Man Show\u201D Remember the Future World Film Festival in Cannes',
            'Certificate of Excellence, Award Winner in Best AI Film, Cinevista Oasis Film Awards',
        ],
    },
    {
        id: 'jonah-oskow',
        name: 'Jonah Oskow',
        role: 'Film Editor · AI Director · Comedy Storyteller',
        bio: "Jonah Oskow is a Brooklyn-based film editor turned AI director with 15 years in commercial post-production, known for storytelling with comedy and visual effects. His AI-directed influencer work has generated millions of views, while his non-commercial projects have appeared on Netflix, Comedy Central online, Crackle, and others. Oskow's personal work has been featured in Shots and the Webby Awards.",
        tags: ['Comedy', 'Branded Content', 'Digital Series'],
        avatarImageUrl: cloudinaryImage('76f983e686d06d8dd4828749ca82454e-1773222009655/oskow.png', 320),
        hoverImageUrl: cloudinaryImage('76f983e686d06d8dd4828749ca82454e-1773222009655/oskow.png', 320),
        reel: {
            id: 'jonah-oskow-reel',
            title: 'Reel',
            videoUrl: rv2('61/johan-oskow-reel2-h', 'w_800'),
            videoUrlVertical: rv2('71/johan-oskow-reel2-v', 'w_400'),
            posterUrl: rv2p('61/johan-oskow-reel2-h'),
            thumbnailUrl: rv2t('61/johan-oskow-reel2-h'),
        },
        videos: [
            {
                id: 'jonah-oskow-1',
                title: 'Video 1',
                videoUrl: v('996/jonah-oskow-1', 'w_800'),
                posterUrl: vp('996/jonah-oskow-1'),
                thumbnailUrl: vt('996/jonah-oskow-1'),
            },
            {
                id: 'jonah-oskow-2',
                title: 'Video 2',
                videoUrl: v('988/jonah-oskow-2', 'w_800'),
                posterUrl: vp('988/jonah-oskow-2'),
                thumbnailUrl: vt('988/jonah-oskow-2'),
            },
            {
                id: 'jonah-oskow-3',
                title: 'Video 3',
                videoUrl: v('992/jonah-oskow-3', 'w_800'),
                posterUrl: vp('992/jonah-oskow-3'),
                thumbnailUrl: vt('992/jonah-oskow-3'),
            },
            {
                id: 'jonah-oskow-4',
                title: 'Video 4',
                videoUrl: v('991/jonah-oskow-4', 'w_800'),
                posterUrl: vp('991/jonah-oskow-4'),
                thumbnailUrl: vt('991/jonah-oskow-4'),
            },
        ],
        clients: ['Netflix', 'Comedy Central'],
        awards: [
            'Best AI-Generated Content, California Music Video & Film Awards',
            'Official Selection, London-Worldwide Comedy Short Film Festival',
        ],
        quote: {
            text: '\u201CJonah sees things other creators don\u2019t. His AI work is some of the most original stuff out there.\u201D',
            authorName: 'David Ma',
            authorTitle: 'Director and Filmmaker',
        },
    },
    {
        id: 'julien-nicaud',
        name: 'Julien Nicaud',
        role: 'Screenwriter · Director · SFX Artist',
        bio: 'Julien Nicaud is a Swiss film director and creative director working at the intersection of cinema and AI. He is known for his immersive long-sequence films and emotionally driven visual storytelling. He uses AI to turn impossible ideas into tangible cinematic experiences.',
        tags: ['Short Films', 'Fashion Film', 'AI Cinema', 'Experimental'],
        avatarImageUrl: cloudinaryImage('76f983e686d06d8dd4828749ca82454e-1773222009661/nicaud.png', 320),
        hoverImageUrl: cloudinaryImage('76f983e686d06d8dd4828749ca82454e-1773222009661/nicaud.png', 320),
        reel: {
            id: 'julien-nicaud-reel',
            title: 'Reel',
            videoUrl: v('991/julien-nicaud-reel-h', 'w_800'),
            videoUrlVertical: rv2('60/julien-nicaud-reel-v', 'w_400'),
            posterUrl: vp('991/julien-nicaud-reel-h'),
            thumbnailUrl: vt('991/julien-nicaud-reel-h'),
        },
        videos: [
            {
                id: 'julien-nicaud-1',
                title: 'Video 1',
                videoUrl: v('995/julien-nicaud-1', 'w_800'),
                posterUrl: vp('995/julien-nicaud-1'),
                thumbnailUrl: vt('995/julien-nicaud-1'),
            },
            {
                id: 'julien-nicaud-3',
                title: 'Video 3',
                videoUrl: v('974/julien-nicaud-3', 'w_800'),
                posterUrl: vp('974/julien-nicaud-3'),
                thumbnailUrl: vt('974/julien-nicaud-3'),
            },
            {
                id: 'julien-nicaud-4',
                title: 'Video 4',
                videoUrl: cloudinaryVideo('62eb8ad4a1b8c2bbe50fedafa2e3de51-1773856612448/julien-nicaud-4', 'w_800'),
                posterUrl: cloudinaryStaticPoster(
                    '62eb8ad4a1b8c2bbe50fedafa2e3de51-1773856612448/julien-nicaud-4',
                    800,
                    25
                ),
                thumbnailUrl: cloudinaryStaticPoster(
                    '62eb8ad4a1b8c2bbe50fedafa2e3de51-1773856612448/julien-nicaud-4',
                    400,
                    25
                ),
            },
            {
                id: 'julien-nicaud-reel-thumb',
                title: 'Reel',
                videoUrl: v('991/julien-nicaud-reel-h', 'w_800'),
                posterUrl: vp('991/julien-nicaud-reel-h'),
                thumbnailUrl: vt('991/julien-nicaud-reel-h'),
            },
        ],
        quote: {
            text: '\u201CJulien is one of the most innovative directors working with AI today. He made the global Dave & Buster\u2019s campaign both ambitious and visually striking.\u201D',
            authorName: 'Antonio Bautista',
            authorTitle: 'Global Hospitality & Entertainment Leader, Dave & Buster\u2019s',
        },
    },
    {
        id: 'too-short-for-modeling',
        name: 'Too Short for Modeling',
        role: 'Writer\u2013Directors · Narrative Disruptors',
        bio: 'TSFM is the writing-directing project from Noam Sharon and Tal Rosenthal. Known for their sharp and offbeat humor, they work across TV shows, commercials, music videos, and more. Blending playful irreverence with strong storytelling instincts, they bring distinctive perspective and character-driven energy to every project.',
        tags: ['Music Videos', 'Commercials'],
        avatarImageUrl: cloudinaryImage(
            'e068b26c805ebc959652b74711ace365-1773919261754/too-short-for-modeling-avatar.png',
            320
        ),
        hoverImageUrl: cloudinaryImage(
            'e068b26c805ebc959652b74711ace365-1773919261754/too-short-for-modeling-avatar.png',
            320
        ),
        reel: {
            id: 'too-short-reel',
            title: 'Reel',
            videoUrl: v('998/too-short-reel-h', 'w_800'),
            videoUrlVertical: rv2('69/too-short-reel-v', 'w_400'),
            posterUrl: vp('998/too-short-reel-h'),
            thumbnailUrl: vt('998/too-short-reel-h'),
        },
        videos: [
            {
                id: 'too-short-1',
                title: 'Video 1',
                videoUrl: v('991/too-short-1', 'w_800'),
                posterUrl: vp('991/too-short-1'),
                thumbnailUrl: vt('991/too-short-1'),
            },
            {
                id: 'too-short-2',
                title: 'Video 2',
                videoUrl: v('973/too-short-2', 'w_800'),
                posterUrl: vp('973/too-short-2'),
                thumbnailUrl: vt('973/too-short-2'),
            },
            {
                id: 'too-short-3',
                title: 'Video 3',
                videoUrl: v('992/too-short-3', 'w_800'),
                posterUrl: vp('992/too-short-3'),
                thumbnailUrl: vt('992/too-short-3'),
            },
            {
                id: 'too-short-4',
                title: 'Video 4',
                videoUrl: v('998/too-short-4', 'w_800'),
                posterUrl: vp('998/too-short-4'),
                thumbnailUrl: vt('998/too-short-4'),
            },
        ],
        clients: ['Waze', 'Google', 'Meta', 'PayPal', 'DoorDash', 'Dollar Shave Club', 'Wix', 'Sodastream'],
        quote: {
            text: '\u201CNoam and Tal are super talented creatives. The work they delivered was truly outstanding, and with them, an excellent final result is absolutely guaranteed.\u201D',
            authorName: 'Liran Friedman',
            authorTitle: 'Creative Director, Artlist',
        },
    },
    {
        id: 'ron-baranov',
        name: 'Ron Baranov',
        role: 'AI filmmaker · Story-Driven Director',
        bio: 'An award-winning AI filmmaker with over 10 years in traditional video production, Ron Baranov creates short brand films, not traditional commercials. His work blends standout storytelling with a sharp sense of humor. His films have received recognition at Runway\'s Gen48 Competition, the OMNI International AI Film Festival, the Chroma Awards, and the "Beyond the Prompt" Competition by LTX Studio.',
        tags: ['Music Video', 'Brand Films', 'Short Films'],
        avatarImageUrl: cloudinaryImage('76f983e686d06d8dd4828749ca82454e-1773222009649/baranov.png', 320),
        hoverImageUrl: cloudinaryImage('76f983e686d06d8dd4828749ca82454e-1773222009649/baranov.png', 320),
        reel: {
            id: 'ron-baranov-reel',
            title: 'Reel',
            videoUrl: v('996/ron-baranov-reel-h', 'w_800'),
            videoUrlVertical: v('978/ron-baranov-reel-v', 'w_400'),
            posterUrl: vp('996/ron-baranov-reel-h'),
            thumbnailUrl: vt('996/ron-baranov-reel-h'),
        },
        videos: [
            {
                id: 'ron-baranov-1',
                title: 'Video 1',
                videoUrl: v('988/ron-baranov-1', 'w_800'),
                posterUrl: vp('988/ron-baranov-1'),
                thumbnailUrl: vt('988/ron-baranov-1'),
            },
            {
                id: 'ron-baranov-2',
                title: 'Video 2',
                videoUrl: v('974/ron-baranov-2', 'w_800'),
                posterUrl: vp('974/ron-baranov-2'),
                thumbnailUrl: vt('974/ron-baranov-2'),
            },
            {
                id: 'ron-baranov-3',
                title: 'Video 3',
                videoUrl: v('996/ron-baranov-3', 'w_800'),
                posterUrl: vp('996/ron-baranov-3'),
                thumbnailUrl: vt('996/ron-baranov-3'),
            },
            {
                id: 'ron-baranov-4',
                title: 'Video 4',
                videoUrl: v('981/ron-baranov-4', 'w_800'),
                posterUrl: vp('981/ron-baranov-4'),
                thumbnailUrl: vt('981/ron-baranov-4'),
            },
        ],
        awards: [
            'Winner of the 5th Edition \u201CGen48 Competition by Runway - People\u2019s Choice Honoree\u201D',
            'Winner of the Silver Cloud Award at the \u201COMNI International AI Film Festival 1.0 Iterations\u201D',
            'Awarded 2nd Place by LTX Studio at the Chroma Awards',
            'Official Selection for the \u201CBeyond the Prompt\u201D Competition by LTX Studio',
        ],
        quote: {
            text: '\u201CIt\u2019s incredible what\u2019s now possible with AI in filmmaking. But to make something that feels human, you need more than good prompts. You need storytelling. That\u2019s where Ron shines. He\u2019s a professional screenwriter and director who\u2019s now pioneering the frontier of AI cinema.\u201D',
            authorName: 'Anthony Sar',
            authorTitle: 'Co-founder, Finoverse',
        },
    },
    {
        id: 'blackstars',
        name: 'Blackstars Studio',
        role: 'Cinematic AI Studio',
        bio: 'Co-founders of the creative studio Blackstars, Wioletta Kulig and Luigi Corvino elevate commercial storytelling through high-end cinematic quality. Merging advanced digital tools with rigorous art direction and traditional craft, they build premium visual narratives for modern businesses. Their work has been trusted by Universal Music, Sony Music UK, Warner Music Group, and Adobe.',
        tags: ['Fashion Film', 'Branded Content', 'Music Videos'],
        avatarImageUrl: cloudinaryImage('76f983e686d06d8dd4828749ca82454e-1773222009658/blackstars.png', 320),
        hoverImageUrl: cloudinaryImage('76f983e686d06d8dd4828749ca82454e-1773222009658/blackstars.png', 320),
        reel: {
            id: 'blackstars-reel',
            title: 'Reel',
            videoUrl: v('977/blackstars-reel-h', 'w_800'),
            videoUrlVertical: rv2('66/blackstars-reel-v', 'w_400'),
            posterUrl: vp('977/blackstars-reel-h'),
            thumbnailUrl: vt('977/blackstars-reel-h'),
        },
        videos: [
            {
                id: 'blackstars-1',
                title: 'Video 1',
                videoUrl: v('992/blackstars-1', 'w_800'),
                posterUrl: vp('992/blackstars-1'),
                thumbnailUrl: vt('992/blackstars-1'),
            },
            {
                id: 'blackstars-2',
                title: 'Video 2',
                videoUrl: v('993/blackstars-2', 'w_800'),
                posterUrl: vp('993/blackstars-2'),
                thumbnailUrl: vt('993/blackstars-2'),
            },
            {
                id: 'blackstars-3',
                title: 'Video 3',
                videoUrl: v('979/blackstars-3', 'w_800'),
                posterUrl: vp('979/blackstars-3'),
                thumbnailUrl: vt('979/blackstars-3'),
            },
            {
                id: 'blackstars-4',
                title: 'Video 4',
                videoUrl: v('979/blackstars-4', 'w_800'),
                posterUrl: vp('979/blackstars-4'),
                thumbnailUrl: vt('979/blackstars-4'),
            },
        ],
        clients: ['Adobe', 'Sony Music', 'Universal Music Group', 'Warner Music Group'],
        quote: {
            text: '\u201CBlackstars didn\u2019t just produce our campaigns, they elevated our entire strategic vision. They have a rare ability to translate complex technologies into accessible, highly human, and visually cinematic storytelling. Their conceptual approach and art direction were instrumental in positioning our brand for a new era.\u201D',
            authorName: 'Global Brand Director',
            authorTitle: 'International Financial Institution',
        },
    },
    {
        id: 'christian-fleischer',
        name: 'The Visiblemaker',
        role: 'AI Film Director \u00B7 Cinematographer',
        bio: 'Working under the moniker The Visiblemaker, Germany-based Christian Fleischer has over 20 years of experience in cinematography, directing, editing, music, and sound design. In 2023, he created The Great Catspy, one of the first AI-generated movie trailers, reaching over 50 million views on X. Focused on cinematic storytelling, humor, and music-driven films, he now works on AI-powered projects for major global clients, including Ferrero Group, Lidl, and Wallism.',
        tags: ['Music-Driven Films', 'Commercials', 'Short Films'],
        avatarImageUrl: cloudinaryImage('76f983e686d06d8dd4828749ca82454e-1773222009647/fleischer.png', 320),
        hoverImageUrl: cloudinaryImage('76f983e686d06d8dd4828749ca82454e-1773222009647/fleischer.png', 320),
        reel: {
            id: 'christian-fleischer-reel',
            title: 'Reel',
            videoUrl: cloudinaryVideo('5b566518aca0953a32c7f0a7249315a7-1773847488737/visiblemaker-reel-h', 'w_800'),
            videoUrlVertical: cloudinaryVideo(
                '5b566518aca0953a32c7f0a7249315a7-1773847488733/visiblemaker-reel-v',
                'w_400'
            ),
            posterUrl: cloudinaryStaticPoster(
                '5b566518aca0953a32c7f0a7249315a7-1773847488737/visiblemaker-reel-h',
                800
            ),
            thumbnailUrl: cloudinaryStaticPoster(
                '5b566518aca0953a32c7f0a7249315a7-1773847488737/visiblemaker-reel-h',
                400
            ),
        },
        videos: [
            {
                id: 'christian-fleischer-1',
                title: 'Video 1',
                videoUrl: wsv('2330/visiblemaker-1', 'w_800'),
                posterUrl: wsvp('2330/visiblemaker-1'),
                thumbnailUrl: wsvt('2330/visiblemaker-1'),
            },
            {
                id: 'christian-fleischer-2',
                title: 'Video 2',
                videoUrl: wsv('2326/visiblemaker-2', 'w_800'),
                posterUrl: wsvp('2326/visiblemaker-2'),
                thumbnailUrl: wsvt('2326/visiblemaker-2'),
            },
            {
                id: 'christian-fleischer-3',
                title: 'Video 3',
                videoUrl: wsv('2332/visiblemaker-3', 'w_800'),
                posterUrl: wsvp('2332/visiblemaker-3'),
                thumbnailUrl: wsvt('2332/visiblemaker-3'),
            },
            {
                id: 'christian-fleischer-4',
                title: 'Video 4',
                videoUrl: wsv('2328/visiblemaker-4', 'w_800'),
                posterUrl: wsvp('2328/visiblemaker-4'),
                thumbnailUrl: wsvt('2328/visiblemaker-4'),
            },
        ],
        clients: ['Lidl', 'Ferrero Group', 'Wallism'],
        awards: [
            '\u201CBest Narrative\u201D at Montpellier AI Festival',
            'Top Ten Nominations of \u201CAIFF Dubai 2024/Expo City Dubai 2024\u201D',
            'Nominated in the Budapest AI Film Festival 2024',
        ],
    },
    {
        id: 'jagger-waters',
        name: 'Jagger Waters',
        role: 'AI Storyteller · Producer · Writer',
        bio: 'Based in Los Angeles, Jagger Waters is a writer and producer with over a decade of experience across film, podcasts, and live events. An early adopter of AI-driven video production, she brings a storyteller-first lens to emerging technology, experimenting with AI to build immersive environments. Her work has been featured at Sundance, SXSW, Cannes AI for Talent Summit, and the Producers Guild of America Magazine.',
        tags: ['Short Films', 'Experimental'],
        avatarImageUrl: cloudinaryImage('e068b26c805ebc959652b74711ace365-1773919261758/jaggers-avatar.png', 320),
        hoverImageUrl: cloudinaryImage('e068b26c805ebc959652b74711ace365-1773919261758/jaggers-avatar.png', 320),
        reel: {
            id: 'jagger-waters-reel',
            title: 'Reel',
            videoUrl: cloudinaryVideo('ff317f32a60c6961a7d5df94aed07a6a-1774304075123/jagger-waters-reel2-h', 'w_800'),
            videoUrlVertical: cloudinaryVideo(
                'ff317f32a60c6961a7d5df94aed07a6a-1774304075127/jagger-waters-reel2-v',
                'w_400'
            ),
            posterUrl: cloudinaryStaticPoster(
                'ff317f32a60c6961a7d5df94aed07a6a-1774304075123/jagger-waters-reel2-h',
                800
            ),
            thumbnailUrl: cloudinaryStaticPoster(
                'ff317f32a60c6961a7d5df94aed07a6a-1774304075123/jagger-waters-reel2-h',
                400
            ),
        },
        videos: [
            {
                id: 'jagger-waters-1',
                title: 'Video 1',
                videoUrl: wsv('2308/jugger-waters-1', 'w_800'),
                posterUrl: cloudinaryStaticPoster(`${WORKSAMPLE_BASE}2308/jugger-waters-1`, 800, 1),
                thumbnailUrl: cloudinaryStaticPoster(`${WORKSAMPLE_BASE}2308/jugger-waters-1`, 400, 1),
            },
            {
                id: 'jagger-waters-2',
                title: 'Video 2',
                videoUrl: wsv('2310/jugger-waters-2', 'w_800'),
                posterUrl: wsvp('2310/jugger-waters-2'),
                thumbnailUrl: wsvt('2310/jugger-waters-2'),
            },
            {
                id: 'jagger-waters-3',
                title: 'Video 3',
                videoUrl: wsv('2313/jugger-waters-3', 'w_800'),
                posterUrl: wsvp('2313/jugger-waters-3'),
                thumbnailUrl: wsvt('2313/jugger-waters-3'),
            },
            {
                id: 'jagger-waters-4',
                title: 'Video 4',
                videoUrl: wsv('2315/jugger-waters-4', 'w_800'),
                posterUrl: wsvp('2315/jugger-waters-4'),
                thumbnailUrl: wsvt('2315/jugger-waters-4'),
            },
        ],
        awards: [
            'Winner of the 1st Annual 48 Hour AI Filmmaking Competition hosted by AI on the Lot (2024)',
            'Winner of the 1st AI eSports Tournament in Las Vegas (2024)',
        ],
        quote: {
            text: '\u201CJagger Waters brings a rare mix of storytelling instincts and real-world understanding of how AI is entering creative production. I\u2019ve seen her speak with both students and industry professionals, and she has a gift for cutting through the hype and explaining what these tools actually mean for working creators. Her perspective is thoughtful, practical, and exactly the kind of voice the industry needs right now.\u201D',
            authorName: 'Justin Trevor Winters',
            authorTitle: 'LMU School of Film & Television | CEO, Verified Labs',
        },
    },
    {
        id: 'alon-seifert',
        name: 'Alon Seifert',
        role: 'Creative Director · Brand Storyteller · Film Director',
        bio: 'Alon Seifert is an independent creative director working across advertising, branding, film, and product development. Drawing on over 30 years of experience, he served as Group Creative Director at McCann NY, leading campaigns for Verizon, Staples, General Mills, and Nikon. He later became the global creative lead on Nespresso, directing teams across Paris, Milan, and London on the iconic George Clooney campaign. Outside of advertising, his creative pursuits have led him to solo and group art exhibitions working in mixed media.',
        tags: ['Commercials', 'Branding'],
        avatarImageUrl: cloudinaryImage('e068b26c805ebc959652b74711ace365-1773919261742/alon-seifert-avatar.png', 320),
        hoverImageUrl: cloudinaryImage('e068b26c805ebc959652b74711ace365-1773919261742/alon-seifert-avatar.png', 320),
        reel: {
            id: 'alon-seifert-reel',
            title: 'Reel',
            videoUrl: rv2('76/alon-seifert-reel2-h', 'w_800'),
            videoUrlVertical: rv2('65/alon-seifert-reel2-v', 'w_400'),
            posterUrl: rv2p('76/alon-seifert-reel2-h'),
            thumbnailUrl: rv2t('76/alon-seifert-reel2-h'),
        },
        videos: [
            {
                id: 'alon-seifert-1',
                title: 'Video 1',
                videoUrl: wsv('2310/alon-seifrat-1', 'w_800'),
                posterUrl: wsvp('2310/alon-seifrat-1'),
                thumbnailUrl: wsvt('2310/alon-seifrat-1'),
            },
            {
                id: 'alon-seifert-2',
                title: 'Video 2',
                videoUrl: wsv('2311/alon-seifrat-2', 'w_800'),
                posterUrl: wsvp('2311/alon-seifrat-2'),
                thumbnailUrl: wsvt('2311/alon-seifrat-2'),
            },
            {
                id: 'alon-seifert-3',
                title: 'Video 3',
                videoUrl: wsv('2324/alon-seifrat-3', 'w_800'),
                posterUrl: wsvp('2324/alon-seifrat-3'),
                thumbnailUrl: wsvt('2324/alon-seifrat-3'),
            },
            {
                id: 'alon-seifert-4',
                title: 'Video 4',
                videoUrl: wsv('2320/alon-seifrat-4', 'w_800'),
                posterUrl: wsvp('2320/alon-seifrat-4'),
                thumbnailUrl: wsvt('2320/alon-seifrat-4'),
            },
        ],
    },
];
